<template>
      <div class="row">
        <div class="col-md-3">
          <HomeCard :total="store.state.user.totals.trialTypes" title="Topologías de ruta" url="TrailTypes">
            <template #icon>
              <el-icon :size="50" >
                <Sunrise />
              </el-icon>

            </template>
          </HomeCard>
        </div>
        <div class="col-md-3">
          <HomeCard :total="store.state.user.totals.trails" title="Rutas" url="Senderos">
            <template #icon>
              <el-icon :size="50" >
                <Sunrise />
              </el-icon>

            </template>
          </HomeCard>
        </div>
          <div class="col-md-3">
             <HomeCard :total="store.state.user.totals.experiences" title="Experiencias" url="Experiencias">
                 <template #icon>
                   <el-icon :size="50" >
                     <MapLocation />
                   </el-icon>

                 </template>
             </HomeCard>
          </div>
        <div class="col-md-3">
          <HomeCard :total="store.state.user.totals.points" title="Puntos de interés" url="Puntos">
            <template #icon>
              <el-icon :size="50" >
                <Coordinate />
              </el-icon>

            </template>
          </HomeCard>
        </div>
        <div class="col-md-3">
        </div>
      </div>
</template>

<script setup>

import HomeCard from "@/views/dashboard/HomeCard.vue";
import {Sunrise,Coordinate} from "@element-plus/icons-vue";
import {onMounted} from "vue";
import {useStore} from "vuex";

const store = useStore()

onMounted(()=>{
    store.dispatch('user/getTotals')
})
</script>

<style scoped>

</style>
